import { getApiV2Client, getAuditReportsExportGipAltReportUrl } from '@mi-front/api-v2';
import { GipAltReportDto } from '@app/modules/audit/modules/global-audit/gip.types';
import { pushTo } from '@app/core/routing';
import { ReportExportInfo } from '../../gip-report/view/components/export-info/ReportExportInfo';
import { GipReportActions } from '../../gip-report/view/components/GipReportActions';
import { GipDetails } from '../../gip-report/view/components/GipReportViewShared';

interface Props {
  readonly report: GipAltReportDto;
}

export function GipAltReportDetail({ report }: Props) {
  return (
    <GipDetails
      report={report}
      actions={
        <GipReportActions
          report={report}
          exportFn={(params) =>
            getApiV2Client().generateUrl(
              getAuditReportsExportGipAltReportUrl(report.id).url,
              { params },
            )
          }
          onClone={() => {
            pushTo(`/audit/global-reports/gip-alternative-report?report=${report.id}`);
          }}
        />
      }
      exportInfo={<ReportExportInfo report={report} />}
    />
  );
}
